import BaseModel from '../core/BaseModel'
export default class FieldsModel extends BaseModel {
    constructor() {
        super({ 
                name: "fields",
                tableName: 'core_field'
            },
            {
            id: { 
                name: 'id', 
                type: "String", 
                label: 'ID', 
                primaryKey: true,
                display: false
            },
            name: { 
                name: 'name', 
                type: "String", 
                label: 'Tên trường dữ liệu',
                filter: { type: 'input',match: 'custom'},
                sortable: true
            },
            
            frontend_type: {
                name: 'frontend_type', label: 'Control Type', type: "Selection", class: 'left disabled-select', dataType: 'Label', width: 15, disabled: true,
            },

            backend_type: {
                name: 'backend_type', label: 'Kiểu dữ liệu', type: "Selection", class: 'left disabled-select', dataType: 'Label', width: 15, disabled: true
               
            }
        },)
    }

}